<template>
  <td class="py-4 pl-4 text-sm font-medium text-gray-900 sm:pl-6 w-8 text-center">
    <AgentAvatar v-bind:agent="agent" />
  </td>
  <td class="py-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6">
    {{agent.attributes.name}}
  </td>
  <td class="py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6 text-center">
    <span class="inline-flex rounded-full px-2 text-xs font-semibold leading-5" :class="{'text-green-800 bg-green-100 ': agent.attributes.confirmed, 'text-gray-800 bg-gray-100 ': !agent.attributes.confirmed}">
      <span v-if="agent.attributes.confirmed">{{ $t('agent.active') }}</span><span v-else>{{ $t('agent.inactive') }}</span>
    </span>
  </td>
  <td class="py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6 text-center">
    <AgentReasonsForResolving :dataset="agentResolveDataset" />
  </td>
  <td class="py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6 text-center">{{messagesCount}}</td>
  <td class="py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6 text-center">{{averageMessageCount}}</td>
  <td class="py-4 pl-4 pr-4 text-sm font-medium text-gray-900 sm:pl-6 text-center">
    <span class="pr-2" v-if="averageReplyTimeAsTime.h > 0">{{averageReplyTimeAsTime.h}} <span class="text-xs">{{ $t('statistics.h') }}</span></span>
    <span class="pr-2" v-if="averageReplyTimeAsTime.m > 0">{{averageReplyTimeAsTime.m}} <span class="text-xs">{{ $t('statistics.m') }}</span></span>
    <span class="pr-2" v-if="averageReplyTimeAsTime.s > 0">{{averageReplyTimeAsTime.s}} <span class="text-xs">{{ $t('statistics.s') }}</span></span>
  </td>
</template>

<script>
import AgentAvatar from '../agents/AgentAvatar.vue'
import { useMessagesByAgentsStore } from '@/stores/messagesByAgent'
import { useAgentAverageStatistics } from '@/stores/agentAverageStatistics';
import { useReasonForResolvingStatisticsStore } from '@/stores/reasonForResolvingAgentStatistics';
import AgentReasonsForResolving from "@/components/statistics/agentReasonsForResolving";

export default {
  name: 'agentStatisticsItem',
  props: ['agent'],
  components: {
    AgentReasonsForResolving,
    AgentAvatar,
  },
  setup() {
    let statisticsStore = useMessagesByAgentsStore();
    let averageStatistics = useAgentAverageStatistics();
    let agentResolvingStatistics = useReasonForResolvingStatisticsStore();
    return { statisticsStore, averageStatistics, agentResolvingStatistics };
  },
  computed: {
    agentResolveDataset() {
      return this.agentResolvingStatistics.getForAgent(this.agent.id);
    },
    messagesCount() {
      let statistics = this.statisticsStore.getById(this.agent.id);
      if (statistics) {
        return statistics.count;
      }
      return 0;
    },
    averageReplyTimeAsTime() {
      let seconds = this.averageReplyTime;
      if (!seconds) {
        return '';
      }
      let minutes = parseInt(seconds / 60);
      let leftoverSeconds = parseInt(seconds - minutes * 60);
      let hours = parseInt(minutes / 60);
      let leftoverMinutes = minutes - hours * 60;

      return {'h': hours, 'm': leftoverMinutes, 's': leftoverSeconds};
    },
    averageReplyTime() {
      let record = this.averageRecord;
      if (record) {
        return record['attributes']['average-first-reply-time-delta'];
      }
      return '';
    },
    averageMessageCount() {
      let record = this.averageRecord;
      if (record) {
        return record['attributes']['average-message-count-per-conversation'];
      }
      return '';
    },
    averageRecord() {
      return this.averageStatistics.getById(this.agent.id);
    }
  },
}
</script>
